import { VEHICLE_STATUS } from 'store/carInstance/constants';

export const BUTTON_TEXT = {
  [VEHICLE_STATUS.NEW]: 'Новый',
  [VEHICLE_STATUS.OLD]: 'С пробегом',
};
